module.exports = __webpack_public_path__ + "static/media/cwiczenie_8.de08ce32.jpg";